@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load activity" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (!Loading || Tabs.length > 0) {
<section class="oep-act" [attr.aria-busy]="Loading">
  <div class="oep-act__head">
    <div>
      <h1 class="oep-act__h1">Activity</h1>
      <p class="oep-act__sub">{{ SeasonCode }} · who has signed in and done their part. Times are US Eastern.</p>
    </div>
    <div class="oep-act__asof">
      <span>{{ AsOf }}</span>
      <button type="button" mjButton variant="outline" [disabled]="Loading" (click)="Refresh()">Refresh</button>
    </div>
  </div>

  <mj-tab-nav class="oep-act__tabs" [Tabs]="Tabs" [ActiveKey]="Role" (TabChange)="SelectRole($event)" />

  <ul class="oep-act__stats">
    @for (t of Tiles; track t.Label) {
      <li class="oep-act__tile">
        <span class="oep-act__tile-label">{{ t.Label }}</span>
        <mj-stat-badge class="oep-act__stat" [Count]="t.Value" [Label]="t.Note" />
      </li>
    }
  </ul>

  <p class="oep-act__status" role="status" aria-live="polite" [attr.data-tone]="Status?.Tone">{{ Status?.Text }}</p>

  <div class="oep-act__panel oep-act__panel--flush">
    <div class="oep-act__bar">
      <h2 class="oep-act__h2" id="oep-act-days">Last 14 days</h2>
      <div class="oep-act__actions">
        <button type="button" mjButton variant="primary" [disabled]="Loading" (click)="ExportPeople()">Export people</button>
        <button type="button" mjButton variant="outline" [disabled]="Loading" (click)="ExportDaily()">Export by day</button>
      </div>
    </div>
    <table class="oep-act__table oep-act__table--days" role="table" aria-labelledby="oep-act-days">
      <thead role="rowgroup">
        <tr role="row">
          <th scope="col" role="columnheader">Day</th>
          <th scope="col" role="columnheader">Signed in</th>
          <th scope="col" role="columnheader">In OEP</th>
          <th scope="col" role="columnheader">First time</th>
          <th scope="col" role="columnheader">Visits</th>
          <th scope="col" role="columnheader">Page views</th>
          @if (Role === 'Presenter') { <th scope="col" role="columnheader">Drafts uploaded</th> }
        </tr>
      </thead>
      <tbody role="rowgroup">
        @for (d of Days; track d.Day) {
          <tr role="row" [class.oep-act__quiet]="d.SignedIn === 0 && d.InOEP === 0 && d.DraftUploads === 0">
            <th scope="row" role="rowheader" class="oep-act__day">{{ d.Label }}</th>
            <td role="cell"><span class="oep-act__label" aria-hidden="true">Signed in</span>{{ d.SignedIn }}</td>
            <td role="cell"><span class="oep-act__label" aria-hidden="true">In OEP</span>{{ d.InOEP }}</td>
            <td role="cell"><span class="oep-act__label" aria-hidden="true">First time</span>{{ d.NewInOEP }}</td>
            <td role="cell"><span class="oep-act__label" aria-hidden="true">Visits</span>{{ d.OEPVisits }}</td>
            <td role="cell"><span class="oep-act__label" aria-hidden="true">Page views</span>{{ d.OEPPageViews }}</td>
            @if (Role === 'Presenter') { <td role="cell"><span class="oep-act__label" aria-hidden="true">Drafts uploaded</span>{{ d.DraftUploads }}</td> }
          </tr>
        }
      </tbody>
    </table>
    <p class="oep-act__defs">Signed in counts people, not sign-in events: the platform records a new one on every reload. A visit is OEP activity with no gap longer than 30 minutes. First time is someone's first day in OEP.</p>
  </div>
</section>
} @else {
  <mj-empty-state Variant="empty" Icon="fa-solid fa-spinner" Title="Loading activity" Message="Fetching the season's activity…" />
}
